import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface ButtonLoadingProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

const useStyles = makeStyles(() => ({
  spinnerSpan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const ButtonLoading = ({
  loading,
  loadingText = 'Läser in...',
  children,
  onClick,
  disabled,
  ...props
}: ButtonLoadingProps) => {
  const classes = useStyles();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!loading && !disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      data-testid="submit-button"
      onClick={handleClick}
      disabled={loading || disabled}
      {...props}
    >
      {loading && (
        <span className={classes.spinnerSpan}>
          <CircularProgress style={{ marginRight: '12px' }} size={16} />
        </span>
      )}
      <span>{loading ? loadingText : children}</span>
    </Button>
  );
};
